const schedulerDetailViewTypes = {
  DETAIL_VIEW_SET_SELECTED_WEEK: "DETAIL_VIEW_SET_SELECTED_WEEK",
  SET_DETAIL_VIEW_SELECTED_SLOTS: "SET_DETAIL_VIEW_SELECTED_SLOTS",
};

export default schedulerDetailViewTypes;
